import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { FaChevronDown, FaBars, FaTimes } from 'react-icons/fa';
import './styles.css';
import logo from '../assets/logo.svg';

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState('');

  // --- STATE UNTUK SCROLL NAVBAR ---
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    let ticking = false;

    const controlNavbar = () => {
      if (typeof window !== 'undefined') {
        const currentScrollY = window.scrollY;

        // Hide jika scroll ke bawah lebih dari 100px DAN menu sedang tidak terbuka
        if (currentScrollY > lastScrollY && currentScrollY > 100 && !isMenuOpen) {
          setIsVisible(false);
        } else {
          // Show jika scroll ke atas
          setIsVisible(true);
        }

        setLastScrollY(currentScrollY);
        ticking = false;
      }
    };

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(controlNavbar);
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup function
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY, isMenuOpen]);

  // Efek untuk disable scroll body saat menu terbuka
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  // --- /STATE UNTUK SCROLL NAVBAR ---

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 992;
      setIsMobile(mobile);
      if (!mobile) {
        // Jika beralih ke desktop, pastikan menu mobile tertutup
        setIsMenuOpen(false);
        setActiveDropdown('');
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Tutup dropdown saat menu utama ditutup
    if (isMenuOpen) {
      setActiveDropdown('');
    }
  };

  const closeMobileMenu = () => {
    setIsMenuOpen(false);
    setActiveDropdown('');
  };

  const handleDropdownToggle = (e, dropdownName) => {
    // Mencegah aksi default dari link yang bisa menyebabkan lompatan halaman
    e.preventDefault();
    // Fungsi ini hanya untuk toggle di mobile, desktop tetap menggunakan CSS hover
    if (isMobile) {
      setActiveDropdown(activeDropdown === dropdownName ? '' : dropdownName);
    }
  };

  return (
    <nav className={`navbar ${isVisible ? 'visible' : 'hidden'}`}>

      <div className="container nav-container">
        <NavLink to="/" className="nav-logo-link" onClick={closeMobileMenu}>
          <img src={logo} alt="SMK Pariwisata Sumbangsih Logo" className="nav-logo-img" />
          <span className="nav-logo-text">
            SMK Pariwisata Sumbangsih
          </span>
        </NavLink>

        <div className="menu-icon" onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </div>

        <div className={`nav-backdrop ${isMenuOpen ? 'active' : ''}`} onClick={closeMobileMenu}></div>

        <ul className={isMenuOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item"><NavLink to="/" end onClick={closeMobileMenu}>Beranda</NavLink></li>
          <li className="nav-item dropdown">
            <a href="#!" className="nav-link-dropdown" onClick={(e) => handleDropdownToggle(e, 'tentang-kami')} aria-expanded={activeDropdown === 'tentang-kami'}>
              Tentang Kami <FaChevronDown size="0.7em" className={activeDropdown === 'tentang-kami' ? 'icon-rotate' : ''} />
            </a>
            <div className={activeDropdown === 'tentang-kami' ? 'dropdown-menu show' : 'dropdown-menu'}>
              <ul>
                <li><NavLink to="/tentang-kami/sambutan" onClick={closeMobileMenu}>Sambutan Kepala Sekolah</NavLink></li>
                <li><NavLink to="/tentang-kami/visi-misi" onClick={closeMobileMenu}>Visi dan Misi</NavLink></li>
                <li><NavLink to="/tentang-kami/sejarah" onClick={closeMobileMenu}>Sejarah Singkat</NavLink></li>
                <li><NavLink to="/tentang-kami/struktur" onClick={closeMobileMenu}>Struktur Organisasi</NavLink></li>
                <li><NavLink to="/tentang-kami/guru-staff" onClick={closeMobileMenu}>Guru dan Staff</NavLink></li>
              </ul>
            </div>
          </li>
          <li className="nav-item"><NavLink to="/jurusan" onClick={closeMobileMenu}>Program Keahlian</NavLink></li>


          {/* Fasilitas Dropdown */}
          <li className="nav-item dropdown">
            <a href="#!" className="nav-link-dropdown" onClick={(e) => handleDropdownToggle(e, 'fasilitas')} aria-expanded={activeDropdown === 'fasilitas'}>
              Fasilitas <FaChevronDown size="0.7em" className={activeDropdown === 'fasilitas' ? 'icon-rotate' : ''} />
            </a>
            <div className={activeDropdown === 'fasilitas' ? 'dropdown-menu show' : 'dropdown-menu'}>
              <ul>
                <li><NavLink to="/pengembangan-akademik" onClick={closeMobileMenu}>Pengembangan Akademik</NavLink></li>
                <li><NavLink to="/ruang-publik" onClick={closeMobileMenu}>Ruang Publik</NavLink></li>
              </ul>
            </div>
          </li>

          {/* Aktivitas Kami Dropdown */}
          <li className="nav-item dropdown">
            <a href="#!" className="nav-link-dropdown" onClick={(e) => handleDropdownToggle(e, 'aktivitas')} aria-expanded={activeDropdown === 'aktivitas'}>
              Aktivitas Kami <FaChevronDown size="0.7em" className={activeDropdown === 'aktivitas' ? 'icon-rotate' : ''} />
            </a>
            <div className={activeDropdown === 'aktivitas' ? 'dropdown-menu show' : 'dropdown-menu'}>
              <ul>
                <li><NavLink to="/berita" onClick={closeMobileMenu}>Berita & Kegiatan</NavLink></li>
                <li><NavLink to="/galeri" onClick={closeMobileMenu}>Galeri</NavLink></li>
                <li><NavLink to="/prestasi" onClick={closeMobileMenu}>Prestasi</NavLink></li>
                <li><NavLink to="/ekstrakurikuler" onClick={closeMobileMenu}>Ekstrakurikuler</NavLink></li>
              </ul>
            </div>
          </li>

          {/* Layanan Kami */}
          <li className="nav-item dropdown">
            <a href="#!" className="nav-link-dropdown" onClick={(e) => handleDropdownToggle(e, 'layanan')} aria-expanded={activeDropdown === 'layanan'}>
              Layanan Kami <FaChevronDown size="0.7em" className={activeDropdown === 'layanan' ? 'icon-rotate' : ''} />
            </a>
            <div className={activeDropdown === 'layanan' ? 'dropdown-menu show' : 'dropdown-menu'}>
              <ul>
                <li><NavLink to="/spmb" onClick={closeMobileMenu}>SPMB Online</NavLink></li>
                <li><NavLink to="/kontak" onClick={closeMobileMenu}>Hubungi Kami</NavLink></li>
              </ul>
            </div>
          </li>

          {/* --- MENU DROPDOWN BARU --- */}
          <li className="nav-item dropdown">
            <a href="#!" className="nav-link-dropdown" onClick={(e) => handleDropdownToggle(e, 'unitkerja')} aria-expanded={activeDropdown === 'unitkerja'}>
              Unit Kerja <FaChevronDown size="0.7em" className={activeDropdown === 'unitkerja' ? 'icon-rotate' : ''} />
            </a>
            <div className={activeDropdown === 'unitkerja' ? 'dropdown-menu show' : 'dropdown-menu'}>
              <ul>
                <li><NavLink to="/kurikulum" onClick={closeMobileMenu}>Waka Kurikulum</NavLink></li>
                <li><NavLink to="/kesiswaan" onClick={closeMobileMenu}>Waka Kesiswaan</NavLink></li>
              </ul>
            </div>
          </li>
          {/* --- AKHIR MENU DROPDOWN --- */}

        </ul>
      </div>
    </nav>
  );
};

export default Navbar;